import "./Framework.module.css";
import Header from "@/reusable_sections/Header";
import StrategicArchitecture from "./sections/StrategicArchitecture";
import GlobalResilienceRoadmap from "./sections/GlobalResilienceRoadmap";
import ComplianceAssurance from "./sections/ComplianceAssurance";
import Footer from "@/reusable_sections/Footer";
export default function FrameworkPage() {
  return <div>
      <Header />
      <StrategicArchitecture />
      <GlobalResilienceRoadmap />
      <ComplianceAssurance />
      <Footer />
    </div>;
}